import {
  ACTIVITY_BUILDER_DRAWER_HISTORY,
  ACTIVITY_BUILDER_DRAWER_ID,
} from '../activity-builder.constants';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import ActivityBuilderHistoryDrawer from 'approot/activity-builder/history/history-drawer';
import * as Styled from 'approot/activity-builder/draft/activity-builder-draft-drawer.style';
import LayoutDrawer from 'approot/shared/layout/layout-drawer';
import { ActivityBuilderDrawerIdWrapper } from 'approot/activity-builder/activity-builder-drawer.style';
import type { GetDraftContentQuery } from './activity-builder-draft.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

const ActivityBuilderDraftDrawer = ({
  interactiveLesson,
}: {
  interactiveLesson: Pluck<GetDraftContentQuery, 'getDraftContent'>;
}) => {
  const { componentDrawerId, isDrawerActive, closeDrawer } =
    useActivityBuilderContext();

  const canShowHistory = !!(
    isDrawerActive && componentDrawerId === ACTIVITY_BUILDER_DRAWER_HISTORY
  );

  return (
    <Styled.ActivityBuilderDraftDrawer $isActive={isDrawerActive}>
      <LayoutDrawer
        isSmall
        isActive={isDrawerActive}
        noScrollOnContainer
        captureKeypress={false}
        onClose={closeDrawer}
      >
        {canShowHistory && (
          <ActivityBuilderHistoryDrawer
            contentId={interactiveLesson.id}
            onClose={closeDrawer}
          />
        )}
        <ActivityBuilderDrawerIdWrapper id={ACTIVITY_BUILDER_DRAWER_ID} />
      </LayoutDrawer>
    </Styled.ActivityBuilderDraftDrawer>
  );
};

export default ActivityBuilderDraftDrawer;
